// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__I7-XD","col":"styles_col__xx-VH"};